import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { Notification } from '../notification';
import { NotificationEvent } from '../notification-event';

/**
 * Component to display a list of toast notifications
 *
 * Usage:
 * <code><pre>
 * // Individual module import
 * import { ToastNotificationListModule } from 'patternfly-ng/notification';
 * // Or
 * import { ToastNotificationListModule } from 'patternfly-ng';
 *
 * // NGX Bootstrap
 * import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';
 *
 * &#64;NgModule({
 *   imports: [ToastNotificationListModule, BsDropdownModule.forRoot(),...],
 *   providers: [BsDropdownConfig]
 * })
 * export class AppModule(){}
 * </pre></code>
 *
 * Optional:
 * <code><pre>
 * import { Notification, NotificationEvent, NotificationType } from 'patternfly-ng/notification';
 * </pre></code>
 */

export class ToastNotificationListComponent implements OnInit {
  /**
   * A list of notifiactions to display
   */
   notifications: Notification[];

  /**
   * Set to true to show close button
   */
   showClose: boolean;

  /**
   * The event emitted when an action has been selected
   */
   onActionSelect = new EventEmitter();

  /**
   * The event emitted when the close button has been selected
   */
   onCloseSelect = new EventEmitter();

  /**
   * The event emitted when the mouse hovers over and leaves a notification
   */
   onViewingChange = new EventEmitter();

  /**
   * The default constructor
   */
  constructor() {
  }

  // Initialization

  /**
   * Setup component configuration upon initialization
   */
  ngOnInit(): void {
  }

  // Actions

  /**
   * Check if the component config has changed
   */
  private handleAction($event: NotificationEvent): void {
    this.onActionSelect.emit($event);
  }

  private handleClose($event: NotificationEvent): void {
    this.onCloseSelect.emit($event);
  }

  private handleViewingChange($event: NotificationEvent) {
    this.onViewingChange.emit($event);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-toast-notification-list',
  template: `<div class="toast-notifications-list-pf" *ngIf="notifications?.length > 0"><div *ngFor="let notification of notifications"><pfng-toast-notification [header]="notification.header" [message]="notification.message" [notification]="notification" [moreActions]="notification.moreActions" [primaryAction]="notification.primaryAction" [showClose]="showClose === true || notification.isPersistent === true" [type]="notification.type" (onActionSelect)="handleAction($event)" (onCloseSelect)="handleClose($event)" (onViewingChange)="handleViewingChange($event)"></pfng-toast-notification></div></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'notifications': [{ type: Input },],
'showClose': [{ type: Input },],
'onActionSelect': [{ type: Output, args: ['onActionSelect', ] },],
'onCloseSelect': [{ type: Output, args: ['onCloseSelect', ] },],
'onViewingChange': [{ type: Output, args: ['onViewingChange', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
